export const agGridKey =
  'CompanyName=XPO Logistics (Boston, MA),LicensedGroup=Enterprise Architecture,' +
  'LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=5,' +
  'LicensedProductionInstancesCount=0,AssetReference=AG-014247,' +
  'ExpiryDate=16_April_2022_[v2]_MTY1MDA2MzYwMDAwMA==f8235caadbde24c608a1217bd9809d38';
